import useForm from "../../../../forms/hooks/useForm";

export default function usePublisherPriceForm() {
	return useForm({});
}
